/**
 * Decides whether an invoice's Interest Note should print.
 *
 * The note was only ever rendered by the "modern" template (InvoicePrintPage),
 * so a society printing on Classic or GST had the note configured under
 * Functional Settings and never saw it. hide_zero_interest_note was declared in
 * settings and honoured by nothing at all.
 *
 * @param {object} config       invoice.configSnapshot.invoice_setting_snapshot
 * @param {number} interestAmount total interest on this invoice (current + arrear)
 * @returns {string|null} the note text to print, or null to print nothing
 */
export const resolveInterestNote = (config = {}, interestAmount = 0) => {
    if (config.show_interest_note !== 1) return null;

    const text = typeof config.interest_notes === 'string'
        ? config.interest_notes.trim()
        : '';
    if (!text) return null;

    // Suppress on invoices that carry no interest, when asked to.
    if (config.hide_zero_interest_note === 1 && !(Number(interestAmount) > 0)) return null;

    return text;
};
